import { cn } from '@/utils/tailwind';
import { LinkOutIcon } from '@/assets/icons/Dashboard';

interface SectionLabelProps {
  title: string;
  className?: string;
  isLinkOutContent?: boolean;
}

export function SectionLabel({ title, className, isLinkOutContent }: SectionLabelProps) {
  return (
    <div className={cn('text-gr-900 flex items-center gap-[8px] Body1S16', className)}>
      <span>{title}</span>
      {isLinkOutContent && <LinkOutIcon className="text-gr-600 h-4 w-4" />}
    </div>
  );
}
